// ─── SEO Data Engine ───
// All cities, states/provinces/regions, languages for programmatic page generation

export const US_CITIES = [
  'New York','Los Angeles','Chicago','Houston','Phoenix','Philadelphia','San Antonio','San Diego','Dallas','San Jose',
  'Austin','Jacksonville','Fort Worth','Columbus','Charlotte','Indianapolis','San Francisco','Seattle','Denver','Washington DC',
  'Nashville','Oklahoma City','El Paso','Boston','Portland','Las Vegas','Memphis','Louisville','Baltimore','Milwaukee',
  'Albuquerque','Tucson','Fresno','Sacramento','Mesa','Kansas City','Atlanta','Omaha','Colorado Springs','Raleigh',
  'Long Beach','Virginia Beach','Miami','Oakland','Minneapolis','Tampa','Tulsa','Arlington','New Orleans','Wichita',
  'Cleveland','Bakersfield','Aurora','Anaheim','Honolulu','Santa Ana','Riverside','Corpus Christi','Lexington','Henderson',
  'Stockton','Saint Paul','Cincinnati','St Louis','Pittsburgh','Greensboro','Lincoln','Orlando','Irvine','Newark',
  'Durham','Chula Vista','Toledo','Fort Wayne','St Petersburg','Laredo','Jersey City','Chandler','Madison','Lubbock',
  'Gilbert','Reno','Buffalo','North Las Vegas','Glendale','Irving','Hialeah','Garland','Scottsdale','Boise',
  'Fremont','Richmond','Baton Rouge','Spokane','Des Moines','Tacoma','San Bernardino','Modesto','Fontana','Moreno Valley',
];

export const UK_CITIES = [
  'London','Birmingham','Manchester','Leeds','Glasgow','Liverpool','Edinburgh','Bristol','Sheffield','Newcastle',
  'Nottingham','Leicester','Cardiff','Belfast','Brighton','Southampton','Plymouth','Reading','Aberdeen','Cambridge',
];

export const CA_CITIES = [
  'Toronto','Montreal','Vancouver','Calgary','Edmonton','Ottawa','Winnipeg','Quebec City','Hamilton','Kitchener',
  'Victoria','Halifax','Saskatoon','Regina','St Johns','Kelowna','Barrie','Windsor','Oshawa','Guelph',
];

export const AU_CITIES = [
  'Sydney','Melbourne','Brisbane','Perth','Adelaide','Gold Coast','Canberra','Newcastle','Hobart','Darwin',
  'Wollongong','Geelong','Townsville','Cairns','Toowoomba','Ballarat','Bendigo','Launceston','Mackay','Rockhampton',
];

export const US_STATES = [
  'Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia',
  'Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland',
  'Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey',
  'New Mexico','New York State','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina',
  'South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming',
];

export const UK_REGIONS = [
  'England','Scotland','Wales','Northern Ireland','East Midlands','West Midlands','Greater London','South East','South West','North West',
  'North East','Yorkshire','East Anglia',
];

export const CA_PROVINCES = [
  'Ontario','Quebec','British Columbia','Alberta','Manitoba','Saskatchewan','Nova Scotia','New Brunswick',
  'Newfoundland and Labrador','Prince Edward Island','Northwest Territories','Yukon','Nunavut',
];

export const AU_STATES = [
  'New South Wales','Victoria','Queensland','Western Australia','South Australia',
  'Tasmania','Australian Capital Territory','Northern Territory',
];

export const LANGUAGES = [
  // Top 50 (original — generate hybrid pages)
  { name: 'Spanish', slug: 'spanish', code: 'es' },
  { name: 'Mandarin Chinese', slug: 'mandarin', code: 'zh' },
  { name: 'Arabic', slug: 'arabic', code: 'ar' },
  { name: 'French', slug: 'french', code: 'fr' },
  { name: 'Vietnamese', slug: 'vietnamese', code: 'vi' },
  { name: 'Korean', slug: 'korean', code: 'ko' },
  { name: 'Russian', slug: 'russian', code: 'ru' },
  { name: 'Portuguese', slug: 'portuguese', code: 'pt' },
  { name: 'Tagalog', slug: 'tagalog', code: 'tl' },
  { name: 'Hindi', slug: 'hindi', code: 'hi' },
  { name: 'Japanese', slug: 'japanese', code: 'ja' },
  { name: 'German', slug: 'german', code: 'de' },
  { name: 'Italian', slug: 'italian', code: 'it' },
  { name: 'Haitian Creole', slug: 'haitian-creole', code: 'ht' },
  { name: 'Polish', slug: 'polish', code: 'pl' },
  { name: 'Urdu', slug: 'urdu', code: 'ur' },
  { name: 'Cantonese', slug: 'cantonese', code: 'yue' },
  { name: 'Farsi', slug: 'farsi', code: 'fa' },
  { name: 'Bengali', slug: 'bengali', code: 'bn' },
  { name: 'Punjabi', slug: 'punjabi', code: 'pa' },
  { name: 'Somali', slug: 'somali', code: 'so' },
  { name: 'Swahili', slug: 'swahili', code: 'sw' },
  { name: 'ASL', slug: 'asl', code: 'asl' },
  { name: 'Turkish', slug: 'turkish', code: 'tr' },
  { name: 'Burmese', slug: 'burmese', code: 'my' },
  { name: 'Thai', slug: 'thai', code: 'th' },
  { name: 'Nepali', slug: 'nepali', code: 'ne' },
  { name: 'Amharic', slug: 'amharic', code: 'am' },
  { name: 'Greek', slug: 'greek', code: 'el' },
  { name: 'Dutch', slug: 'dutch', code: 'nl' },
  { name: 'Hebrew', slug: 'hebrew', code: 'he' },
  { name: 'Khmer', slug: 'khmer', code: 'km' },
  { name: 'Hmong', slug: 'hmong', code: 'hmn' },
  { name: 'Gujarati', slug: 'gujarati', code: 'gu' },
  { name: 'Tamil', slug: 'tamil', code: 'ta' },
  { name: 'Telugu', slug: 'telugu', code: 'te' },
  { name: 'Pashto', slug: 'pashto', code: 'ps' },
  { name: 'Romanian', slug: 'romanian', code: 'ro' },
  { name: 'Czech', slug: 'czech', code: 'cs' },
  { name: 'Hungarian', slug: 'hungarian', code: 'hu' },
  { name: 'Ukrainian', slug: 'ukrainian', code: 'uk' },
  { name: 'Serbian', slug: 'serbian', code: 'sr' },
  { name: 'Croatian', slug: 'croatian', code: 'hr' },
  { name: 'Bosnian', slug: 'bosnian', code: 'bs' },
  { name: 'Albanian', slug: 'albanian', code: 'sq' },
  { name: 'Indonesian', slug: 'indonesian', code: 'id' },
  { name: 'Malay', slug: 'malay', code: 'ms' },
  { name: 'Tigrinya', slug: 'tigrinya', code: 'ti' },
  { name: 'Dari', slug: 'dari', code: 'prs' },
  { name: 'Yoruba', slug: 'yoruba', code: 'yo' },
  // 51-100: Major world languages spoken in the US
  { name: 'Marathi', slug: 'marathi', code: 'mr' },
  { name: 'Kannada', slug: 'kannada', code: 'kn' },
  { name: 'Malayalam', slug: 'malayalam', code: 'ml' },
  { name: 'Oriya', slug: 'oriya', code: 'or' },
  { name: 'Assamese', slug: 'assamese', code: 'as' },
  { name: 'Sinhala', slug: 'sinhala', code: 'si' },
  { name: 'Lao', slug: 'lao', code: 'lo' },
  { name: 'Karen', slug: 'karen', code: 'kar' },
  { name: 'Chin', slug: 'chin', code: 'cnh' },
  { name: 'Zomi', slug: 'zomi', code: 'zom' },
  { name: 'Hakha Chin', slug: 'hakha-chin', code: 'cnk' },
  { name: 'Mizo', slug: 'mizo', code: 'lus' },
  { name: 'Tedim Chin', slug: 'tedim-chin', code: 'ctd' },
  { name: 'Rohingya', slug: 'rohingya', code: 'rhg' },
  { name: 'Kurdish', slug: 'kurdish', code: 'ku' },
  { name: 'Kurdish Sorani', slug: 'kurdish-sorani', code: 'ckb' },
  { name: 'Kurdish Kurmanji', slug: 'kurdish-kurmanji', code: 'kmr' },
  { name: 'Igbo', slug: 'igbo', code: 'ig' },
  { name: 'Hausa', slug: 'hausa', code: 'ha' },
  { name: 'Twi', slug: 'twi', code: 'tw' },
  { name: 'Akan', slug: 'akan', code: 'ak' },
  { name: 'Ga', slug: 'ga-language', code: 'gaa' },
  { name: 'Ewe', slug: 'ewe', code: 'ee' },
  { name: 'Wolof', slug: 'wolof', code: 'wo' },
  { name: 'Fulani', slug: 'fulani', code: 'ff' },
  { name: 'Lingala', slug: 'lingala', code: 'ln' },
  { name: 'Kinyarwanda', slug: 'kinyarwanda', code: 'rw' },
  { name: 'Kirundi', slug: 'kirundi', code: 'rn' },
  { name: 'Shona', slug: 'shona', code: 'sn' },
  { name: 'Ndebele', slug: 'ndebele', code: 'nd' },
  { name: 'Zulu', slug: 'zulu', code: 'zu' },
  { name: 'Xhosa', slug: 'xhosa', code: 'xh' },
  { name: 'Afrikaans', slug: 'afrikaans', code: 'af' },
  { name: 'Sotho', slug: 'sotho', code: 'st' },
  { name: 'Tswana', slug: 'tswana', code: 'tn' },
  { name: 'Sesotho', slug: 'sesotho', code: 'nso' },
  { name: 'Malagasy', slug: 'malagasy', code: 'mg' },
  { name: 'Oromo', slug: 'oromo', code: 'om' },
  { name: 'Luganda', slug: 'luganda', code: 'lg' },
  { name: 'Chichewa', slug: 'chichewa', code: 'ny' },
  { name: 'Bambara', slug: 'bambara', code: 'bm' },
  { name: 'Mandinka', slug: 'mandinka', code: 'mnk' },
  { name: 'Fula', slug: 'fula', code: 'ful' },
  { name: 'Soninke', slug: 'soninke', code: 'snk' },
  { name: 'Mende', slug: 'mende', code: 'men' },
  { name: 'Temne', slug: 'temne', code: 'tem' },
  { name: 'Krio', slug: 'krio', code: 'kri' },
  { name: 'Pidgin English', slug: 'pidgin-english', code: 'pcm' },
  { name: 'Cape Verdean Creole', slug: 'cape-verdean-creole', code: 'kea' },
  { name: 'Jamaican Patois', slug: 'jamaican-patois', code: 'jam' },
  // 101-150: European, Central Asian, and Middle Eastern languages
  { name: 'Bulgarian', slug: 'bulgarian', code: 'bg' },
  { name: 'Slovak', slug: 'slovak', code: 'sk' },
  { name: 'Slovenian', slug: 'slovenian', code: 'sl' },
  { name: 'Lithuanian', slug: 'lithuanian', code: 'lt' },
  { name: 'Latvian', slug: 'latvian', code: 'lv' },
  { name: 'Estonian', slug: 'estonian', code: 'et' },
  { name: 'Finnish', slug: 'finnish', code: 'fi' },
  { name: 'Swedish', slug: 'swedish', code: 'sv' },
  { name: 'Norwegian', slug: 'norwegian', code: 'no' },
  { name: 'Danish', slug: 'danish', code: 'da' },
  { name: 'Icelandic', slug: 'icelandic', code: 'is' },
  { name: 'Catalan', slug: 'catalan', code: 'ca' },
  { name: 'Basque', slug: 'basque', code: 'eu' },
  { name: 'Galician', slug: 'galician', code: 'gl' },
  { name: 'Maltese', slug: 'maltese', code: 'mt' },
  { name: 'Georgian', slug: 'georgian', code: 'ka' },
  { name: 'Armenian', slug: 'armenian', code: 'hy' },
  { name: 'Azerbaijani', slug: 'azerbaijani', code: 'az' },
  { name: 'Uzbek', slug: 'uzbek', code: 'uz' },
  { name: 'Kazakh', slug: 'kazakh', code: 'kk' },
  { name: 'Tajik', slug: 'tajik', code: 'tg' },
  { name: 'Turkmen', slug: 'turkmen', code: 'tk' },
  { name: 'Kyrgyz', slug: 'kyrgyz', code: 'ky' },
  { name: 'Mongolian', slug: 'mongolian', code: 'mn' },
  { name: 'Belarusian', slug: 'belarusian', code: 'be' },
  { name: 'Macedonian', slug: 'macedonian', code: 'mk' },
  { name: 'Montenegrin', slug: 'montenegrin', code: 'cnr' },
  { name: 'Luxembourgish', slug: 'luxembourgish', code: 'lb' },
  { name: 'Romansh', slug: 'romansh', code: 'rm' },
  { name: 'Yiddish', slug: 'yiddish', code: 'yi' },
  { name: 'Ladino', slug: 'ladino', code: 'lad' },
  { name: 'Aramaic', slug: 'aramaic', code: 'arc' },
  { name: 'Assyrian', slug: 'assyrian', code: 'aii' },
  { name: 'Chaldean', slug: 'chaldean', code: 'cld' },
  { name: 'Syriac', slug: 'syriac', code: 'syc' },
  { name: 'Tigre', slug: 'tigre', code: 'tig' },
  { name: 'Maltese Arabic', slug: 'maltese-arabic', code: 'mlt' },
  { name: 'Persian', slug: 'persian', code: 'fas' },
  { name: 'Balochi', slug: 'balochi', code: 'bal' },
  { name: 'Sindhi', slug: 'sindhi', code: 'sd' },
  { name: 'Kashmiri', slug: 'kashmiri', code: 'ks' },
  { name: 'Brahui', slug: 'brahui', code: 'brh' },
  { name: 'Hazaragi', slug: 'hazaragi', code: 'haz' },
  { name: 'Pampangan', slug: 'pampangan', code: 'pam' },
  { name: 'Ilocano', slug: 'ilocano', code: 'ilo' },
  { name: 'Cebuano', slug: 'cebuano', code: 'ceb' },
  { name: 'Hiligaynon', slug: 'hiligaynon', code: 'hil' },
  { name: 'Waray', slug: 'waray', code: 'war' },
  { name: 'Bikol', slug: 'bikol', code: 'bik' },
  { name: 'Pangasinan', slug: 'pangasinan', code: 'pag' },
  // 151-200: Southeast Asian, Pacific Islander, and additional languages
  { name: 'Javanese', slug: 'javanese', code: 'jv' },
  { name: 'Sundanese', slug: 'sundanese', code: 'su' },
  { name: 'Madurese', slug: 'madurese', code: 'mad' },
  { name: 'Minangkabau', slug: 'minangkabau', code: 'min' },
  { name: 'Balinese', slug: 'balinese', code: 'ban' },
  { name: 'Acehnese', slug: 'acehnese', code: 'ace' },
  { name: 'Tetum', slug: 'tetum', code: 'tet' },
  { name: 'Tok Pisin', slug: 'tok-pisin', code: 'tpi' },
  { name: 'Samoan', slug: 'samoan', code: 'sm' },
  { name: 'Tongan', slug: 'tongan', code: 'to' },
  { name: 'Fijian', slug: 'fijian', code: 'fj' },
  { name: 'Hawaiian', slug: 'hawaiian', code: 'haw' },
  { name: 'Marshallese', slug: 'marshallese', code: 'mh' },
  { name: 'Chamorro', slug: 'chamorro', code: 'ch' },
  { name: 'Chuukese', slug: 'chuukese', code: 'chk' },
  { name: 'Pohnpeian', slug: 'pohnpeian', code: 'pon' },
  { name: 'Yapese', slug: 'yapese', code: 'yap' },
  { name: 'Palauan', slug: 'palauan', code: 'pau' },
  { name: 'Kosraean', slug: 'kosraean', code: 'kos' },
  { name: 'Tibetan', slug: 'tibetan', code: 'bo' },
  { name: 'Dzongkha', slug: 'dzongkha', code: 'dz' },
  { name: 'Sherpa', slug: 'sherpa', code: 'xsr' },
  { name: 'Maithili', slug: 'maithili', code: 'mai' },
  { name: 'Bhojpuri', slug: 'bhojpuri', code: 'bho' },
  { name: 'Rajasthani', slug: 'rajasthani', code: 'raj' },
  { name: 'Konkani', slug: 'konkani', code: 'kok' },
  { name: 'Dogri', slug: 'dogri', code: 'doi' },
  { name: 'Manipuri', slug: 'manipuri', code: 'mni' },
  { name: 'Bodo', slug: 'bodo', code: 'brx' },
  { name: 'Santali', slug: 'santali', code: 'sat' },
  { name: 'Chhattisgarhi', slug: 'chhattisgarhi', code: 'hne' },
  { name: 'Magahi', slug: 'magahi', code: 'mag' },
  { name: 'Awadhi', slug: 'awadhi', code: 'awa' },
  { name: 'Marwari', slug: 'marwari', code: 'mwr' },
  { name: 'Tulu', slug: 'tulu', code: 'tcy' },
  { name: 'Kodava', slug: 'kodava', code: 'kfa' },
  { name: 'Meitei', slug: 'meitei', code: 'mei' },
  { name: 'Khasi', slug: 'khasi', code: 'kha' },
  { name: 'Garo', slug: 'garo', code: 'grt' },
  { name: 'Naga', slug: 'naga', code: 'nag' },
  { name: 'Shan', slug: 'shan', code: 'shn' },
  { name: 'Mon', slug: 'mon', code: 'mnw' },
  { name: 'Karenni', slug: 'karenni', code: 'kyu' },
  { name: 'Kachin', slug: 'kachin', code: 'kac' },
  { name: 'Wa', slug: 'wa-language', code: 'wbm' },
  { name: 'Sgaw Karen', slug: 'sgaw-karen', code: 'ksw' },
  { name: 'Pwo Karen', slug: 'pwo-karen', code: 'kjp' },
  { name: 'Kayah', slug: 'kayah', code: 'kxf' },
  { name: 'Rakhine', slug: 'rakhine', code: 'rki' },
  { name: 'Chittagonian', slug: 'chittagonian', code: 'ctg' },
  // 201-250: Americas indigenous, creoles, and additional world languages
  { name: 'Navajo', slug: 'navajo', code: 'nv' },
  { name: 'Cherokee', slug: 'cherokee', code: 'chr' },
  { name: 'Lakota', slug: 'lakota', code: 'lkt' },
  { name: 'Ojibwe', slug: 'ojibwe', code: 'oj' },
  { name: 'Cree', slug: 'cree', code: 'cr' },
  { name: 'Inuktitut', slug: 'inuktitut', code: 'iu' },
  { name: 'Yupik', slug: 'yupik', code: 'esu' },
  { name: 'Tlingit', slug: 'tlingit', code: 'tli' },
  { name: 'Apache', slug: 'apache', code: 'apw' },
  { name: 'Choctaw', slug: 'choctaw', code: 'cho' },
  { name: 'Quechua', slug: 'quechua', code: 'qu' },
  { name: 'Aymara', slug: 'aymara', code: 'ay' },
  { name: 'Guarani', slug: 'guarani', code: 'gn' },
  { name: 'Nahuatl', slug: 'nahuatl', code: 'nah' },
  { name: 'Maya', slug: 'maya', code: 'yua' },
  { name: 'Kiche', slug: 'kiche', code: 'quc' },
  { name: 'Mam', slug: 'mam', code: 'mam' },
  { name: 'Kanjobal', slug: 'kanjobal', code: 'kjb' },
  { name: 'Mixtec', slug: 'mixtec', code: 'mix' },
  { name: 'Zapotec', slug: 'zapotec', code: 'zap' },
  { name: 'Garifuna', slug: 'garifuna', code: 'cab' },
  { name: 'Miskito', slug: 'miskito', code: 'miq' },
  { name: 'Brazilian Portuguese', slug: 'brazilian-portuguese', code: 'pt-br' },
  { name: 'European Portuguese', slug: 'european-portuguese', code: 'pt-pt' },
  { name: 'Latin American Spanish', slug: 'latin-american-spanish', code: 'es-419' },
  { name: 'European Spanish', slug: 'european-spanish', code: 'es-es' },
  { name: 'Canadian French', slug: 'canadian-french', code: 'fr-ca' },
  { name: 'Swiss German', slug: 'swiss-german', code: 'gsw' },
  { name: 'Swiss French', slug: 'swiss-french', code: 'fr-ch' },
  { name: 'Swiss Italian', slug: 'swiss-italian', code: 'it-ch' },
  { name: 'French Creole', slug: 'french-creole', code: 'gcf' },
  { name: 'Mauritian Creole', slug: 'mauritian-creole', code: 'mfe' },
  { name: 'Seychellois Creole', slug: 'seychellois-creole', code: 'crs' },
  { name: 'Papiamento', slug: 'papiamento', code: 'pap' },
  { name: 'Sranan Tongo', slug: 'sranan-tongo', code: 'srn' },
  { name: 'Saraiki', slug: 'saraiki', code: 'skr' },
  { name: 'Tausug', slug: 'tausug', code: 'tsg' },
  { name: 'Maranao', slug: 'maranao', code: 'mrw' },
  { name: 'Maguindanao', slug: 'maguindanao', code: 'mdh' },
  { name: 'Chuukese', slug: 'trukese', code: 'trk' },
  { name: 'Carolinian', slug: 'carolinian', code: 'cal' },
  { name: 'Bislama', slug: 'bislama', code: 'bi' },
  { name: 'Hiri Motu', slug: 'hiri-motu', code: 'ho' },
  { name: 'Solomon Islands Pijin', slug: 'solomon-islands-pijin', code: 'pis' },
  { name: 'Tahitian', slug: 'tahitian', code: 'ty' },
  { name: 'Maori', slug: 'maori', code: 'mi' },
  { name: 'Cook Islands Maori', slug: 'cook-islands-maori', code: 'rar' },
  { name: 'Niuean', slug: 'niuean', code: 'niu' },
  { name: 'Tokelauan', slug: 'tokelauan', code: 'tkl' },
  { name: 'Tuvaluan', slug: 'tuvaluan', code: 'tvl' },
];

// Top 10 languages for hybrid pages
export const TOP_LANGUAGES = LANGUAGES.slice(0, 10);
// Top 50 US cities for hybrid pages
export const TOP_US_CITIES = US_CITIES.slice(0, 50);

export const SERVICES = [
  { name: 'Phone Interpreting', slug: 'phone-interpreting', short: 'OPI' },
  { name: 'Video Remote Interpreting', slug: 'video-interpreting', short: 'VRI' },
  { name: 'On-Site Interpreting', slug: 'on-site-interpreting', short: 'On-Site' },
  { name: 'AI Interpreting', slug: 'ai-interpreting', short: 'AI' },
];

export const INDUSTRIES = [
  { name: 'Healthcare', slug: 'healthcare-interpreting-services', icon: 'Stethoscope' },
  { name: 'Legal & Court', slug: 'legal-interpreting-services', icon: 'Scale' },
  { name: 'Government', slug: 'government-interpreting-services', icon: 'Landmark' },
  { name: 'Corporate', slug: 'corporate-interpreting-services', icon: 'Building' },
  { name: 'Schools & Education', slug: 'education-interpreting-services', icon: 'GraduationCap' },
  { name: 'Policing & Law Enforcement', slug: 'policing-interpreting-services', icon: 'Shield' },
  { name: 'Immigration', slug: 'immigration-interpreting-services', icon: 'Globe' },
  { name: 'Corrections & Prisons', slug: 'corrections-interpreting-services', icon: 'Building' },
  { name: 'Call Centers', slug: 'call-centers-interpreting-services', icon: 'Headphones' },
];

// Utility: slug from name
export function toSlug(name) {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

// Deterministic hash for consistent linking (no randomness for SEO crawlability)
function stableHash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

// Get 3 related cities deterministically based on current slug
export function getRelatedCities(currentSlug, count = 3) {
  const all = [...US_CITIES, ...UK_CITIES, ...CA_CITIES, ...AU_CITIES];
  const filtered = all.filter(c => toSlug(c) !== currentSlug);
  const offset = stableHash(currentSlug || 'home') % Math.max(filtered.length - count, 1);
  return filtered.slice(offset, offset + count);
}

// Get 3 related languages deterministically
export function getRelatedLanguages(currentSlug, count = 3) {
  const filtered = LANGUAGES.filter(l => l.slug !== currentSlug);
  const offset = stableHash(currentSlug || 'home') % Math.max(filtered.length - count, 1);
  return filtered.slice(offset, offset + count);
}

// Get 2 related services deterministically
export function getRelatedServices(currentSlug, count = 2) {
  const filtered = SERVICES.filter(s => s.slug !== currentSlug);
  const offset = stableHash(currentSlug || 'home') % Math.max(filtered.length - count, 1);
  return filtered.slice(offset, offset + count);
}

// Get country for city
export function getCityCountry(city) {
  if (UK_CITIES.includes(city)) return 'United Kingdom';
  if (CA_CITIES.includes(city)) return 'Canada';
  if (AU_CITIES.includes(city)) return 'Australia';
  return 'United States';
}

// Get state for city (simplified)
export function getCityState(city) {
  const map = {
    'New York': 'New York', 'Los Angeles': 'California', 'Chicago': 'Illinois', 'Houston': 'Texas',
    'Phoenix': 'Arizona', 'Philadelphia': 'Pennsylvania', 'San Antonio': 'Texas', 'San Diego': 'California',
    'Dallas': 'Texas', 'San Jose': 'California', 'Austin': 'Texas', 'San Francisco': 'California',
    'Seattle': 'Washington', 'Denver': 'Colorado', 'Washington DC': 'District of Columbia',
    'Boston': 'Massachusetts', 'Nashville': 'Tennessee', 'Las Vegas': 'Nevada', 'Miami': 'Florida',
    'Atlanta': 'Georgia', 'Minneapolis': 'Minnesota', 'Tampa': 'Florida', 'Orlando': 'Florida',
    'Portland': 'Oregon', 'Sacramento': 'California', 'Pittsburgh': 'Pennsylvania', 'Cleveland': 'Ohio',
    'London': 'England', 'Birmingham': 'England', 'Manchester': 'England', 'Toronto': 'Ontario',
    'Vancouver': 'British Columbia', 'Montreal': 'Quebec', 'Calgary': 'Alberta',
    'Sydney': 'New South Wales', 'Melbourne': 'Victoria', 'Brisbane': 'Queensland', 'Perth': 'Western Australia',
    'Adelaide': 'South Australia', 'Gold Coast': 'Queensland', 'Canberra': 'Australian Capital Territory',
    'Newcastle': 'New South Wales', 'Hobart': 'Tasmania', 'Darwin': 'Northern Territory',
    'Wollongong': 'New South Wales', 'Geelong': 'Victoria', 'Townsville': 'Queensland', 'Cairns': 'Queensland',
    'Toowoomba': 'Queensland', 'Ballarat': 'Victoria', 'Bendigo': 'Victoria', 'Launceston': 'Tasmania',
  };
  return map[city] || '';
}
